import { render, staticRenderFns } from "./Detections.vue?vue&type=template&id=089768a6&scoped=true"
import script from "./Detections.vue?vue&type=script&lang=js"
export * from "./Detections.vue?vue&type=script&lang=js"
import style0 from "./Detections.vue?vue&type=style&index=0&id=089768a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089768a6",
  null
  
)

export default component.exports